import { useEffect, useState } from 'react'
import { useUser } from 'reactfire'

// Mirrors useIsAutomationAdmin: when impersonating, only the impersonator's
// original admin claim counts. An admin impersonating a non-admin must NOT
// gain admin access through the impersonated user.
export function useIsAdmin(): {
  isAdmin: boolean
  loading: boolean
} {
  const { data: user } = useUser()
  const [state, setState] = useState({
    isAdmin: false,
    loading: true,
  })

  useEffect(() => {
    if (!user) {
      setState({ isAdmin: false, loading: true })
      return
    }
    let cancelled = false
    user
      .getIdTokenResult()
      .then((result) => {
        if (cancelled) return
        const { claims } = result
        const isAdmin = claims.impersonating
          ? claims.impersonator_admin === true
          : claims.admin === true
        setState({ isAdmin, loading: false })
      })
      .catch(() => {
        if (cancelled) return
        setState({ isAdmin: false, loading: false })
      })
    return () => {
      cancelled = true
    }
  }, [user])

  return state
}
